module.exports = __webpack_public_path__ + "assets/img/FLETEPENDIENTECOTIZACION.08a8376c.svg";